import React from "react";

const CardShimmer = ({ rows = 2, columns = 3 }) => {
  const totalCards = rows * columns;

  return (
    <div
      className={`grid gap-4 sm:gap-6 mt-10`}
      style={{
        gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
      }}
    >
      {[...Array(totalCards)].map((_, i) => (
        <div
          key={i}
          className="bg-white  rounded-xl shadow-sm border border-gray-200  p-4 sm:p-6 animate-pulse"
        >
          {/* Header shimmer */}
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-full bg-gray-200 "></div>
            <div className="flex-1">
              <div className="h-4 bg-gray-200  rounded w-3/4 mb-2"></div>
              <div className="h-3 bg-gray-200  rounded w-1/2"></div>
            </div>
          </div>

          {/* Content shimmer lines */}
          <div className="space-y-3">
            <div className="h-3 bg-gray-200  rounded w-full"></div>
            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
            <div className="h-3 bg-gray-200  rounded w-2/3"></div>
          </div>

          {/* Footer shimmer */}
          <div className="mt-5 h-9 bg-gray-200  rounded-lg w-full"></div>
        </div>
      ))}
    </div>
  );
};

export default CardShimmer;
